let csrfToken: string | null = null;
let tokenPromise: Promise<string> | null = null;

export async function getCSRFToken(): Promise<string> {
  if (csrfToken) {
    return csrfToken;
  }

  if (tokenPromise) {
    return tokenPromise;
  }

  tokenPromise = fetch("/api/csrf-token", { credentials: "include" })
    .then(res => res.json())
    .then(data => {
      csrfToken = data.csrfToken;
      tokenPromise = null;
      return csrfToken as string;
    })
    .catch(err => {
      tokenPromise = null;
      console.error("Failed to fetch CSRF token:", err);
      throw err;
    });

  return tokenPromise as Promise<string>;
}

export function clearCSRFToken(): void {
  csrfToken = null;
  tokenPromise = null;
}

export function setCSRFToken(token: string): void {
  csrfToken = token;
  tokenPromise = null;
}

export async function fetchWithCSRF<T>(url: string, options?: RequestInit): Promise<T> {
  const method = options?.method?.toUpperCase() || "GET";
  
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(options?.headers as Record<string, string>),
  };

  if (!["GET", "HEAD", "OPTIONS"].includes(method)) {
    const token = await getCSRFToken();
    headers["X-CSRF-Token"] = token;
  }

  const res = await fetch(url, {
    ...options,
    headers,
    credentials: "include",
  });

  if (!res.ok) {
    if (res.status === 403) {
      const error = await res.json().catch(() => ({}));
      if (error.error?.includes("CSRF")) {
        clearCSRFToken();
        const newToken = await getCSRFToken();
        headers["X-CSRF-Token"] = newToken;
        const retryRes = await fetch(url, {
          ...options,
          headers,
          credentials: "include",
        });
        if (!retryRes.ok) {
          const retryError = await retryRes.json().catch(() => ({ error: "Error de red" }));
          throw new Error(retryError.error || "Error de red");
        }
        return retryRes.json();
      }
    }
    const error = await res.json().catch(() => ({ error: "Error de red" }));
    throw new Error(error.error || "Error de red");
  }

  return res.json();
}
